import React from 'react';
import { Route, Redirect } from 'react-router-dom';



const AppRoute = ({
  component: Component,
  layout: Layout,
  isAuthProtected,
  requireAdmin,
  BApath,
  ...rest
}) => {
  console.log(Component);
  return <Route
    {...rest}
    render={(props) => {
      if (localStorage.getItem('loanAuth')) {
        const token = JSON.parse(atob(JSON.parse(localStorage.getItem('loanAuth')).token.split('.')[1])).exp * 1000
        if (token < Date.now()) {
          console.log({ token })
          localStorage.removeItem('loanAuth')
          localStorage.removeItem('authUser')
          return (
            <Redirect
              to={{ pathname: '/login', state: { from: props.location } }}
            />
          )
        }
      }
      if(isAuthProtected === false){
        console.log(rest.path)
        return (
          // <Redirect to={{pathname: rest.path}}/>
          <Layout>
          <Component {...props} />
        </Layout>
        )
      }
      if (isAuthProtected && (!localStorage.getItem('authUser') || !localStorage.getItem('loanAuth')) && (!localStorage.getItem('bankAdmin'))) {
        // console.log(isAuthProtected && (!localStorage.getItem('authUser') || !localStorage.getItem('loanAuth')) && (!localStorage.getItem('bankAdmin')), 'route 28')
        return (
          <Redirect
            to={{ pathname: '/login', state: { from: props.location } }}
          />
        );
      }
      // console.log('sdfsdfsdfds') 
      if(isAuthProtected && JSON.parse(localStorage.getItem('bankAdmin')) && !BApath){
        console.log({BApath})
        return (
          <Redirect 
          to={{pathname: '/loan-list-bank', state: {from: props.location}}}
          />
          )
        }
        else if (requireAdmin && JSON.parse(localStorage.getItem('authUser'))?.data?.userType === "CCR") {
        return (
          <Redirect
            to={{ pathname: '/baythak', state: { from: props.location } }}
          />
        );
      }
      return (
        <Layout>
          <Component {...props} />
        </Layout>
      );
    }}
  />
  };

export default AppRoute;
